export default __webpack_public_path__ + "static/media/hslExcel.69aaf340.svg";